export default __webpack_public_path__ + "static/media/telegramDeskFill.81334f50.svg";